<div class="flex flex-col full-grow-no-shrink-no-basis">
  <div class="modal-header flex flex-row justify-between items-center" mat-dialog-title>
    <h1>Update Company</h1>

    <mat-dialog-actions>
      <button class="material-icons" mat-dialog-close
              particleAnalytics
              analyticsCategory="ed-cell-editor-container"
              analyticsAction="close-btn">close
      </button>
    </mat-dialog-actions>

  </div>

  <div mat-dialog-content class="full-grow-no-shrink-no-basis">
    <div class="orbitax-form-container">
      <form class="flex flex-col flex-1-0-auto " [formGroup]="updateCompanyForm"
            (keydown.enter)="$event.preventDefault()">
        <div class="flex flex-col flex-1-0-auto ">

          <div class="flex flex-row justify-start items-start auto-flex">
            <mat-form-field appearance="outline" class="flex-1-1-100">
              <mat-label>Company Name</mat-label>
              <input matInput required formControlName="companyName"
                     particleAnalytics
                     analyticsCategory="account-settings"
                     analyticsAction="password-input">
              <mat-error *ngIf="updateCompanyFormErrors.companyName.hasOwnProperty('required')">
                Company name is required.
              </mat-error>
            </mat-form-field>
          </div>

          <div class="flex flex-row justify-start items-start auto-flex">
            <mat-form-field appearance="outline" class="flex-1-1-100">
              <mat-label>Description</mat-label>
              <input matInput formControlName="description"
                     particleAnalytics
                     analyticsCategory="account-settings"
                     analyticsAction="password-input">
            </mat-form-field>
          </div>

          <!--<div fxLayout="row" fxLayoutAlign="start start" fxFlex="0 0 auto">
            <mat-form-field appearance="outline" fxFlex="100">
              <mat-label>Source</mat-label>
              <input matInput formControlName="source"
                     particleAnalytics
                     analyticsCategory="account-settings"
                     analyticsAction="password-input">
            </mat-form-field>
          </div>-->

          <div class="flex flex-row justify-start items-start auto-flex">
            <mat-form-field appearance="outline" class="flex-1-1-100">
              <mat-label>Domain</mat-label>
              <input matInput formControlName="domain"
                     particleAnalytics
                     analyticsCategory="account-settings"
                     analyticsAction="password-input">
            </mat-form-field>
          </div>

          <div class="flex flex-row justify-start items-start auto-flex">
            <mat-checkbox formControlName="isActive">Is Active</mat-checkbox>
          </div>

        </div>
      </form>
    </div>
  </div>

  <mat-dialog-actions class="modal-footer flex flex-row justify-between items-center">
    <button mat-button class="mat-flat-button orbitax-footer-button mat-button" [mat-dialog-close]="result">Cancel
    </button>
    <button mat-button (click)="onSave()" [mat-dialog-close]="result" mat-flat-button
            class="orbitax-footer-action-button mat-button mat-flat-button mat-accent" type="button" color="accent"
            [disabled]="!updateCompanyForm.valid" cdkFocusInitial>Save
    </button>
  </mat-dialog-actions>
</div>
